'use client';

import { usePathname } from 'next/navigation';
import { RefObject, useEffect } from 'react';

import { apiGtm } from '../lib/apiGtm';

interface GTMReadReviewProps {
  refItem: RefObject<HTMLElement | null>;
  productName: string | null | undefined;
}

export const GTMReadReview = ({ refItem, productName }: GTMReadReviewProps) => {
  const pathname = usePathname();

  useEffect(() => {
    const itemElement = refItem.current;
    if (!itemElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        observer.unobserve(itemElement);
        apiGtm.readReview(pathname, productName);
      },
      { threshold: 0.5, rootMargin: '0px 0px 0px 0px' }
    );

    observer.observe(itemElement);

    return () => observer.disconnect();
  }, [refItem, pathname, productName]);

  return null;
};
